// "Instalar la app": en Android el navegador ofrece el aviso (`beforeinstallprompt`), que se guarda para mostrarlo
// cuando el cliente toca el botón. En iPhone no existe: se explica cómo agregarla a la pantalla de inicio.
import { create } from 'zustand';

interface AvisoInstalar extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

interface EstadoInstalar {
  aviso: AvisoInstalar | null;
  instalada: boolean;
}

const enModoApp = () =>
  typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true);

export const useInstalar = create<EstadoInstalar>(() => ({ aviso: null, instalada: enModoApp() }));

export const esIPhone = (): boolean =>
  typeof navigator !== 'undefined' &&
  (/iphone|ipad|ipod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

/** Se llama al arrancar, antes de pintar: el aviso llega una sola vez y temprano. */
export function escucharInstalacion(): void {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    useInstalar.setState({ aviso: e as AvisoInstalar });
  });
  window.addEventListener('appinstalled', () => useInstalar.setState({ aviso: null, instalada: true }));
}

export async function instalar(): Promise<boolean> {
  const { aviso } = useInstalar.getState();
  if (!aviso) return false;
  await aviso.prompt();
  const { outcome } = await aviso.userChoice;
  useInstalar.setState({ aviso: null, instalada: outcome === 'accepted' });
  return outcome === 'accepted';
}
